<template>
  <div class="relative md:aspect-[1440/731]">
    <template v-if="themeStore.current === 'layby'">
      <picture>
        <source media="(min-width: 768px)" :srcset="layupBanner" />
        <source media="(max-width: 767px)" :srcset="layupBannerMobile" />
        <img
          :src="layupBanner"
          alt="LayUp Banner"
          fetchpriority="high"
          class="absolute inset-0 w-full h-full object-cover"
        />
      </picture>
      <div
        class="max-w-3xl relative z-10 flex flex-col gap-4 md:gap-10 mx-auto items-center md:justify-center min-h-[731px] px-4 py-14 text-center md:absolute md:inset-0 md:max-w-190 md:min-h-0"
      >
        <h1 class="text-white text-5xl lg:text-[91px] font-extrabold md:max-w-3xl">Own What You Love, Debt-Free</h1>
        <p class="max-w-xl text-white text-md md:text-2xl italic">
          Flexible, interest-free digital lay-by that puts financial freedom back in your hands.
        </p>
        <ProductSelector />
      </div>
    </template>
    <template v-else-if="themeStore.current === 'plans'">
      <picture>
        <source media="(min-width: 768px)" :srcset="plansBanner" />
        <source media="(max-width: 767px)" :srcset="plansBannerMobile" />
        <img
          :src="plansBanner"
          alt="Boost Banner"
          fetchpriority="high"
          class="absolute inset-0 w-full h-full object-cover"
        />
      </picture>
      <div
        class="max-w-3xl relative z-10 flex flex-col gap-4 md:gap-10 mx-auto items-center md:justify-center min-h-[731px] px-4 py-14 text-center md:absolute md:inset-0 md:max-w-190 md:min-h-0"
      >
        <h1 class="text-white text-5xl md:text-8xl font-extrabold md:max-w-3xl">
          Africa just got a smarter way to travel
        </h1>
        <p class="max-w-xl text-white text-md md:text-2xl italic">
          Split your next trip or event into simple monthly instalments. No interest. No credit check.
        </p>
        <ProductSelector />
      </div>
    </template>
    <template v-else-if="themeStore.current === 'boost'">
      <img :src="boostBanner" alt="Boost Banner" class="absolute inset-0 w-full h-full object-cover" />
      <picture>
        <source media="(min-width: 768px)" :srcset="boostBanner" />
        <source media="(max-width: 767px)" :srcset="boostBannerMobile" />
        <img
          :src="boostBanner"
          alt="Boost Banner"
          fetchpriority="high"
          class="absolute inset-0 w-full h-full object-cover"
        />
      </picture>
      <div
        class="max-w-3xl relative z-10 flex flex-col gap-4 md:gap-10 mx-auto items-center md:justify-center min-h-[731px] px-4 py-14 text-center md:absolute md:inset-0 md:max-w-none md:min-h-0"
      >
        <h1 class="text-white text-5xl md:text-8xl font-extrabold md:max-w-3xl">Save Smart. Earn Big.</h1>
        <p class="max-w-lg text-white text-sm md:text-2xl italic">
          BOOST helps you build healthy saving habits while rewarding you with real value.
        </p>
        <ProductSelector />
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import boostBanner from '@/assets/images/boost-banner.webp';
import layupBanner from '@/assets/images/layup-banner.webp';
import boostBannerMobile from '@/assets/images/layup-boost-banner-mobile.webp';
import layupBannerMobile from '@/assets/images/layup-layby-banner-mobile.webp';
import plansBannerMobile from '@/assets/images/plans-banner-mobile.png';
import plansBanner from '@/assets/images/plans-banner.webp';
import { useThemeStore } from '@/stores/theme';
import ProductSelector from './ProductSelector.vue';

const themeStore = useThemeStore();
</script>
